import stickybits from 'stickybits'
import ready from 'ready'

ready(() => {
  stickybits(".global-event-list .calendar-block-date", {stickyBitStickyOffset: 20, useFixed: true})
})
